import classNames from 'classnames';

// styles
import s from './Radio.sss';

// types
export type RadioProps = React.HTMLProps<HTMLInputElement>;

export const Radio: React.FC<RadioProps> = ({
  className,
  ...props
}) => (
  <label
    className={
      classNames(
        s.radioLabel,
        { [s.disabled]: props.disabled },
        className,
      )
    }
    htmlFor={props.id}
  >
    <input
      {...props}
      className={s.radioCheckbox}
      type="radio"
    />
    <span
      className={
        classNames(
          s.radioButton,
          { [s.active]: props.checked },
        )
      }
    />
  </label>
);
